import { useState, useEffect, useRef } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import {clsx} from "clsx";
import {MegamenuFeaturedImage} from "./MegamenuFeaturedImage";
import React from "react";

export const MegamenuFeaturedImages = ({ settings, block, megamenuSM }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    return (
        <>
            {!isMobile && megamenuSM.featuredImageBlocks.length > 0 && (
                <div className={`menu__featured--blocks pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_desktop}px] pl-[${block.settings.padding_left_desktop}px] pr-[${block.settings.padding_right_desktop}px]`}>
                    <div
                        className={`menu__featured--blocks__grid ${clsx({
                            "stacked grid grid-cols-1":
                                settings.section.image_layout == "stacked",
                            [`grid grid-cols-${megamenuSM.featuredImageBlocks.length}`]:
                            settings.section.image_layout == "grid",
                            [`grid-cols-${settings.section.col_count}`]:
                            megamenuSM.featuredImageBlocks.length == 1 &&
                            settings.section.image_layout == "grid",
                        })}`}
                    >
                        {megamenuSM.featuredImageBlocks.map((block, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: settings.section.image_spacing,
                                }}
                            >
                                <MegamenuFeaturedImage
                                    index={index}
                                    blockItem={block}
                                    settings={settings}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {isMobile && megamenuSM.featuredImageBlocks.length > 0 && (
                <div className={`mobile-menu__featured--blocks pt-[${block.settings.padding_top_mobile}px] pb-[${block.settings.padding_bottom_mobile}px] pl-[${block.settings.padding_left_mobile}px] pr-[${block.settings.padding_right_mobile}px]`}>
                    <div className={`megamenu__title ${settings.title_style}`}>Featured</div>
                    <div
                        className={`mobile-menu__featured--blocks__grid ${clsx({
                            "stacked grid grid-cols-1":
                                settings.section.image_layout == "stacked",
                            [`grid grid-cols-${megamenuSM.featuredImageBlocks.length}`]:
                            settings.section.image_layout == "grid",
                            [`grid-cols-${settings.section.col_count}`]:
                            megamenuSM.featuredImageBlocks.length == 1 &&
                            settings.section.image_layout == "grid",
                        })}`}
                    >
                        {megamenuSM.featuredImageBlocks.map((block, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: settings.section.image_spacing,
                                }}
                            >
                                <MegamenuFeaturedImage
                                    index={index}
                                    blockItem={block}
                                    settings={settings}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

